import { getApiBase } from './apiBase';
import { filtersToSearchParams } from './reconExceptionFilters';

/**
 * Download exceptions as Excel or PDF (respects current filters).
 * @param {'xlsx'|'pdf'} format
 * @param {Record<string, string>} filters
 */
export async function downloadExceptionExport(format, filters = {}) {
  const params = filtersToSearchParams(filters, {});
  params.set('format', format);
  const base = getApiBase();
  const res = await fetch(`${base}/api/recon/exceptions/export?${params}`, {
    credentials: 'include',
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Export failed. Try again.');
  }
  const blob = await res.blob();
  const cd = res.headers.get('Content-Disposition') || '';
  const match = /filename="([^"]+)"/i.exec(cd);
  const filename =
    match?.[1] || `adp-recon-exceptions.${format === 'pdf' ? 'pdf' : 'xlsx'}`;
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
